import script from "./AboutCertSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutCertSection.vue?vue&type=script&setup=true&lang=js"

import "./AboutCertSection.vue?vue&type=style&index=0&id=dfd39fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd39fc0"]])

export default __exports__